import enabled from './enabled';

export default {
	mixins: [enabled],
	data() {
		return {
			focus: false
		};
	},
	methods: {
		focus_on() {
			this.focus = this.enabled;
		},
		focus_off() {
			this.focus = false;
		}
	}
};